import { ApolloClient, ApolloLink, InMemoryCache, HttpLink } from "apollo-boost"
import fetch from "isomorphic-fetch"
import { readCookie } from "../utils/cookies"

const httpLink = new HttpLink({ uri: `${process.env.GATSBY_MAGENTO_URL}graphql` })

const authMiddleware = new ApolloLink((operation, forward) => {
  
  const customHeaders = operation.getContext()?.headers
    ? operation.getContext().headers
    : {}

  let gatsbytoken = readCookie('gatsbytoken') ? `Bearer ${readCookie('gatsbytoken')}` : undefined

  // add the bearer token and any other headers passed
  operation.setContext({
    headers: {
      ...customHeaders,
      authorization: `Bearer ${gatsbytoken}`
    }
  })
  return forward(operation)
})

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authMiddleware.concat(httpLink),
  fetch
})

/*
 * export const client = new ApolloClient({
 *   uri: `${process.env.GATSBY_MAGENTO_URL}graphql`,
 *   request: operation => {
 *     operation.setContext({
 *       headers: {
 *         Authorization: readCookie('gatsbytoken')
 *           ? `Bearer ${readCookie('gatsbytoken')}`
 *           : undefined,
 *       },
 *     })
 *   },
 *   fetch
 * })
 */
